import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyCYA3vE7utBSSijew9RKnHwXsERRwzAwdo',
  authDomain: 'daily-bible-reading-app.firebaseapp.com',
  projectId: 'daily-bible-reading-app',
  storageBucket: 'daily-bible-reading-app.firebasestorage.app',
  messagingSenderId: '151599417280',
  appId: '1:151599417280:web:e5720b3a599c0b09fcea25',
  measurementId: 'G-5BGKRFVLM8',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export const db = getFirestore(app);

// Initialize Firebase Cloud Messaging and get a reference to the service
export const messaging = getMessaging(app);
